/** Session keys for tenant-scoped plan checkout / pending payment (shared by onboarding + billing). */

export const TENANT_SESSION_SELECTED_PLAN_ID_PREFIX = 'lp_selected_plan_id';
export const TENANT_SESSION_PENDING_ACTIVATION_PREFIX = 'lp_pending_activation';
export const TENANT_SESSION_PENDING_AT_PREFIX = 'lp_pending_activation_at';

export function tenantSessionPlanIdKey(slug: string): string {
  const s = (slug ?? '').trim();
  return s
    ? `${TENANT_SESSION_SELECTED_PLAN_ID_PREFIX}:${s}`
    : TENANT_SESSION_SELECTED_PLAN_ID_PREFIX;
}

export function tenantSessionPendingKey(slug: string): string {
  const s = (slug ?? '').trim();
  return s
    ? `${TENANT_SESSION_PENDING_ACTIVATION_PREFIX}:${s}`
    : TENANT_SESSION_PENDING_ACTIVATION_PREFIX;
}

export function tenantSessionPendingAtKey(slug: string): string {
  const s = (slug ?? '').trim();
  return s
    ? `${TENANT_SESSION_PENDING_AT_PREFIX}:${s}`
    : TENANT_SESSION_PENDING_AT_PREFIX;
}

/**
 * Removes all tenant plan / pending-checkout flags from sessionStorage.
 * Call when the authenticated tenant id changes (signup, login, tenant switch) so a
 * recreated tenant with the same slug does not inherit stale pending-payment state.
 */
export function clearAllTenantPlanCheckoutSessionKeys(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  const keys: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const k = sessionStorage.key(i);
    if (k) keys.push(k);
  }
  const sel = TENANT_SESSION_SELECTED_PLAN_ID_PREFIX;
  const pend = TENANT_SESSION_PENDING_ACTIVATION_PREFIX;
  const pendAt = TENANT_SESSION_PENDING_AT_PREFIX;
  for (const key of keys) {
    const remove =
      key.startsWith(sel) ||
      key.startsWith(pendAt) ||
      key === pend ||
      key.startsWith(`${pend}:`);
    if (remove) {
      sessionStorage.removeItem(key);
    }
  }
}

export function buildTenantSelectedPlanId(
  planCode: string,
  billingCycle: 'monthly' | 'yearly',
): string {
  return `${(planCode ?? '').trim()}_${billingCycle}`;
}

export function parseTenantSelectedPlanId(
  planId: string,
): { planCode: string; billingCycle: 'monthly' | 'yearly' } {
  const s = (planId ?? '').trim();
  const parts = s.split('_');
  const last = parts[parts.length - 1]?.toLowerCase();
  if (last !== 'monthly' && last !== 'yearly') {
    throw new Error('Invalid planId billing cycle');
  }
  const billingCycle = last as 'monthly' | 'yearly';
  const planCode = parts.slice(0, -1).join('_');
  if (!planCode) throw new Error('Invalid planId');
  return { planCode, billingCycle };
}
